import { Button, Kind } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('cms.content.app_navigation.bottom_nav.tab')

type Props = {
  index: number
  onEdit: () => void
}

const Header: React.FC<Props> = ({ index, onEdit }) => {
  return (
    <div className="d-flex align-items-center justify-content-between mb-s">
      <Text.Header4 className="mb-0">
        {t('title', { number: index + 1 })}
      </Text.Header4>
      <div className="d-flex">
        <Button onClick={onEdit} kind={Kind.MINIMAL} className="p-0">
          <Text.BodyText3 tag="span" className="ml-xs mb-0" color="primary">
            {t('edit')}
          </Text.BodyText3>
        </Button>
      </div>
    </div>
  )
}

export default Header
